import { useTranslation } from "react-i18next";

export default function CategoryMostUi ({value}) {

    const { t } = useTranslation();

    return(<>
        <div className='bg-thirdly rounded-lg p-5 mt-1'>
            <label className='text-white font-semiblod text-xl text-right'>{t("charts.most_searched_categories")}</label>
            <div className='flex sm:flex-row flex-col sm:justify-between sm:items-center gap-8 px-4 mt-5 mb-4'>

                {value?.most_search_categories?.map((category) => (
                    <div key={category?.id} className='flex sm:flex-row flex-col justify-center items-center'>
                        <img 
                            src={category?.logo} 
                            className='w-14 h-14 rounded-lg' 
                            alt={category?.name}
                        />
                        <div className='sm:ms-4 text-center sm:text-start'>
                            <h2 className='text-white text-bold text-md'> {category?.name}</h2>
                            {/* <p className='text-white text-bold text-sm mt-2'>{category?.description?.substring(0,40)}</p> */}
                        </div>
                    </div>
                ))}

            </div>
        </div>  
    </>);
};